/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class InfraVulnerabilitiesTrendSummaryRequest extends models.InfraIssuesTimeRangeFilter {
    getFixupPrototypeFunction() { return InfraVulnerabilitiesTrendSummaryRequest.fixupPrototype; }

    static newInstance(model: Partial<InfraVulnerabilitiesTrendSummaryRequest>): InfraVulnerabilitiesTrendSummaryRequest {
        let obj = Object.assign(new InfraVulnerabilitiesTrendSummaryRequest(), model);
        InfraVulnerabilitiesTrendSummaryRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<InfraVulnerabilitiesTrendSummaryRequest>): InfraVulnerabilitiesTrendSummaryRequest {
        if (!model) return null;
        return InfraVulnerabilitiesTrendSummaryRequest.newInstance(<InfraVulnerabilitiesTrendSummaryRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: InfraVulnerabilitiesTrendSummaryRequest) {
        if (!obj) return;

        models.InfraVulnerabilitiesTrendSummaryRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: InfraVulnerabilitiesTrendSummaryRequest): boolean {
        if (models.InfraIssuesTimeRangeFilter.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, InfraVulnerabilitiesTrendSummaryRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.filters) {
            models.SecurityInfraIssuesDashboardFilters.fixupPrototype(this.filters);
        }
    }

    /**
     * Fields to group the infrastructure vulnerability results
     */
    group_by: Array<models.InfraVulnerabilitiesTrendGroupBy>;

    /**
     * Filters applied to the issues trend data.
     */
    filters: models.SecurityInfraIssuesDashboardFilters;

}
